import { render, staticRenderFns } from "./NewPlacementWarningModal.vue?vue&type=template&id=028f17de"
import script from "./NewPlacementWarningModal.vue?vue&type=script&lang=js"
export * from "./NewPlacementWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports